import { createApp } from 'vue'
import App from './App.vue'
import {store} from "@/Common/store/store";
import VueGtag from 'vue-gtag';

createApp(App).use(store).use(VueGtag, {
    config: {
        id: 'G-MVRNREJ2QJ',
    },
}).mount('#app')
